import Tag from '@/modules/tag'
import Consent from './consent'


export default {

    setPage: function (vue, page, meta = true) {

        if (meta) {

            vue.$store.dispatch('setPage', page)
        }
        Tag.pageViewAmplitude(vue, page)
    },

    getSettingsPathUsingInvalidGrant: function (invalidGrant) {
        switch(invalidGrant) {
            case true:
                return '/settings?ig=true'
            case false:
            default:
                return '/settings'
        }
    },

    // Used only from the magic link form
    getLoginPathPostMagicForm: function ({provider, invalidGrant, isOAuth}) {
        return buildLoginPathUsingProviderAndInvalidGrant({provider, invalidGrant, isOAuth})
    },

    // Take into account invalidGrant to false in order to return /magic-request-email
    getLoginPathUsingProviderAndInvalidGrant: function ({provider, invalidGrant, isOAuth}) {
        switch(invalidGrant) {
            case true:
                return buildLoginPathUsingProviderAndInvalidGrant({provider, invalidGrant, isOAuth})
            case false:
                return '/magic-request-email'
            default:
                return buildLoginPathUsingProviderAndInvalidGrant({provider, invalidGrant, isOAuth})
        }
    }

}

// Private

function buildLoginPathUsingProviderAndInvalidGrant({provider, invalidGrant, isOAuth}) {
    const loginPath = ((isOAuth) ? '/login-o-auth' : '/login') + `/${provider}`
    if (invalidGrant === true) {
        return `${loginPath}?ig=true`
    }
    if (invalidGrant === false) {
        return `${loginPath}`
    }
    // This test is usefull when the user is connected and add a new account.
    // In this case , the consent is not required.
    if (Consent.isRequiredToConsentOnThisDevice()) {
        return `/consent-page?provider=${provider}&toPath=${loginPath}`
    }
    return `${loginPath}`
}
